import type { Task } from '../services/taskService';

import { formatPhaseCredits } from './phaseBuildPresentation';

/** Structural planning rows describe artifacts but do not each incur a charge.
 * A captured flag distinguishes those rows from a real zero-cost snapshot. */
export const hasPlanningTaskCredit = (
  task: Pick<Task, 'task_type' | 'planning_metadata'>,
): boolean => (
  task.task_type === 'planning'
  && task.planning_metadata?.credit_price_captured === true
  && task.planning_metadata?.credit_not_required !== true
);

/** Planning prices are persisted by the backend, so the UI must display that
 * amount instead of applying the current model or plan. */
export const planningTaskCreditAmount = (
  task: Pick<Task, 'prompt_credit'>,
): number => {
  const amount = Number(task.prompt_credit);

  return Number.isFinite(amount) ? Math.max(0, amount) : 0;
};

export const formatPlanningTaskCredits = (
  task: Pick<Task, 'prompt_credit'>,
): string => formatPhaseCredits(planningTaskCreditAmount(task));

export const planningTaskCreditLabel = (
  task: Pick<Task, 'planning_credit_charged'>,
): string => task.planning_credit_charged ? 'Credits used' : 'Credits needed';

export const planningTaskCreditShortLabel = (
  task: Pick<Task, 'planning_credit_charged'>,
): string => task.planning_credit_charged ? 'used' : 'needed';

export const planningTaskCreditTitle = (
  task: Pick<Task, 'planning_credit_charged'>,
): string => task.planning_credit_charged
  ? 'This cost was deducted when the planning task started'
  : 'This saved estimate is finalized for the authenticated billing account when the planning task starts';
